import axios from 'axios';
import Cookies from 'js-cookie';

import { API_URL, API_VERSION } from '../ApiUrl';

class Axios {
  defaultOptions = () => {
    return {
      baseURL: `${API_URL}${API_VERSION}`,
      headers: {
        token: Cookies.get('token'),
        restaurantid: Cookies.get('_id'),
      },
    };
  };

  // Safely read a message field from response data without assuming JSON shape
  safeGetMessage = (res) => {
    try {
      if (!res || !res.data) return '';
      // if it's a string and contains 'Not Authorized'
      if (typeof res.data === 'string') return res.data;
      // if it's a blob/arraybuffer, no message
      if (res.data instanceof ArrayBuffer || (res.data && typeof res.data.byteLength === 'number')) return '';
      if (typeof res.data === 'object' && res.data.message) return String(res.data.message);
      return '';
    } catch (e) {
      return '';
    }
  };
  // Clears everything tied to the logged-in pharmacy so the next login on
  // this browser doesn't inherit stale values (e.g. myrx_id / golivro_id).
  clearSessionCookies() {
    [
      'token',
      '_id',
      'name',
      'role',
      'categories',
      'user_id',
      'restaurantStatus',
      'featureAccess',
      'province',
      'pharmacyAddress',
      'myrx_id',
      'golivro_id',
    ].forEach((name) => Cookies.remove(name));

    // Legacy 'golivro_serviceable_<pharmacyId>' cache cookies from the old
    // On Ship availability check.
    Object.keys(Cookies.get()).forEach((name) => {
      if (name.indexOf('golivro_serviceable_') === 0) {
        Cookies.remove(name);
        Cookies.remove(name, { path: '/' });
      }
    });
  }

  LogoutUser = (url) => {
    if (url.response !== undefined && url.response.status === 401) {
      console.log(url.response.status, '401 Unauthorized Api Call');
      this.clearSessionCookies();
      window.location.replace('/');
    } else {
      console.log(url, '401 Unauthorized Api Call');
    }
  };

  get = (url, options = {}) => {
    return axios
      .get(url, { ...this.defaultOptions(), ...options })
      .then((res) => {
        const msg = this.safeGetMessage(res);
        if (msg && msg.includes('Not Authorized')) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        // guard against missing err.response
        if (err && err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  post = (url, data, options = {}) => {
    return axios
      .post(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => {
        const msg = this.safeGetMessage(res);
        if (msg && msg.includes('Not Authorized')) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  put = (url, data, options = {}) => {
    return axios
      .put(url, data, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message.includes('Not Authorized')) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };

  delete = (url, options = {}) => {
    return axios
      .delete(url, { ...this.defaultOptions(), ...options })
      .then((res) => {
        if (res.data.message.includes('Not Authorized')) {
          let err = {
            response: {
              status: 401,
            },
          };
          this.LogoutUser(err);
        } else {
          return res;
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.LogoutUser(err);
          return err;
        } else {
          return err;
        }
      });
  };
}

export default new Axios();
